<template>
  <li v-bind:class="{active, dropdown: isDropdown}" :data-id="id">
    <a :href="href" v-on:click="handleClick" v-bind:class="{'dropdown-toggle': isDropdown}" :data-toggle="isDropdown">
      <template v-if="icon">
        <div class="icon sidemenu-item">
          <i :class="['fa', iconClass]" aria-hidden="true"></i>

          <div class="badge" v-if="indicator && indicatorValue"><span>{{indicatorValue}}</span></div>
        </div>
        <div class="title">{{ localTitle }}</div>
      </template>
      <template v-else>
        {{ localTitle }}
      </template>
    </a>
    <div v-if="isDropdown" class="dropdown-menu">
      <ul>
        <!-- <li class="section"><i class="fa fa-file-o" aria-hidden="true"></i> UI Kits</li> -->
        <li v-for="(link, index) in children"><a :href="link.href" v-on:click="dispatchLink(link)"></a></li>
      </ul>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    children: {
      type: Array,
      default: function() {
        return [];
      }
    },
    id: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: ''
    },
    index: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'cube'
    },
    iconPrefix: {
      type: String,
      default: 'fa'
    },
    title: {},
    indicator: {},
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    if (this.indicator) {
      this.timer = setInterval(() => this.updateIndicator(), 120000);
      this.updateIndicator();
    }
  },
  data() {
    return {
      indicatorValue: null,
    }
  },
  computed: {
    isDropdown () {
      return this.children.length > 0;
    },
    href () {
      return this.url.indexOf('http') === 0 ? this.url : null;
    },
    iconClass() {
      return typeof this.icon == 'undefined' ? '' : `${this.iconPrefix || 'fa'}-${this.icon}`;
    },
    localTitle() {
      return (typeof this.title == 'object') && this.title.hasOwnProperty(this.$i18n.locale)
        ? this.title[this.$i18n.locale]
        : this.title;
    }
  },
  ready () {

  },
  methods: {
    async updateIndicator () {
      try {
        const params = Object.assign({}, this.indicator.params, {count: 1});
        const {data} = await this.$http.get(this.$root.url + this.indicator.api, {params});
        this.indicatorValue = typeof data.result === 'object' ? data.result.count : data.result;
      } catch (e) {
        console.log('Failed to update indicator', e);
      }
    },
    handleClick (evt) {
      this.dispatchLink(this, evt);
    },
    dispatchLink (link, evt) {
      this.$emit('click', link);
      if (typeof link.onClick !== 'undefined') {
        link.onClick();
      } else if (typeof link.url !== 'undefined' && this.url.indexOf('http') == -1) {
        this.$parent.$parent.openView(this.url, this.index);
      }
    },
    refreshIndicator(filter) {
      if (this.indicator && this.indicator.api.startsWith(filter)) {
        this.indicatorValue = null;
        this.updateIndicator();
      }
    }
  }
}
</script>
<style scoped>
  .sidemenu-item {
    position: relative;
  }
  .badge {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 50%;
    display: block;
    background: red;
    transform: translate(50%, -50%);
    width: 24px
  }

  .badge::before {
    content: ' ';
    display: block;
    padding-top: 100%;
  }

  .badge span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
  }
</style>
